/* Regiuni in care NU se livreaza (malul stang / Transnistria).
   Folosit de checkout ca a doua plasa de siguranta: dropdown-ul de localitate
   (md-localities.js) nu mai contine localitatile de pe malul stang, dar campul
   de adresa este text liber, deci clientul poate scrie acolo "Тирасполь, ул. ...".

   ATENTIE la extindere: termenii se compara pe CUVANT INTREG, dar exista
   omonime legitime pe malul drept care NU au voie sa intre in lista:
     - "Slobozia"  -> sat in Stefan Voda (transnistreanul se scrie "Слободзея")
     - "Camenca"   -> sat in Riscani
     - "Pervomaisc"-> sat in Causeni
     - "Dubasari"  -> raion pe malul drept (orasul transnistrean e "Дубоссары")
   Inainte de a adauga un termen, verifica-l contra window.MD_LOCALITIES. */
(function () {
  var TERMS = [
    // Tiraspol
    'tiraspol', 'тирасполь', 'тираспол',
    // Bender. NU adauga "Tighina": in Chisinau exista strada Tighina, deci
    // termenul ar bloca adrese perfect valide de pe malul drept.
    'bender', 'bendery', 'бендеры', 'бендер',
    // Ribnita
    'ribnita', 'rîbnița', 'rybnitsa', 'рыбница',
    // Dubasari-oras (grafia ruseasca; raionul de pe dreapta ramane valid)
    'dubossary', 'дубоссары',
    // Grigoriopol
    'grigoriopol', 'григориополь',
    // Slobozia transnistreana (NU "Slobozia" din Stefan Voda)
    'slobodzeya', 'slobodzia', 'слободзея',
    // Dnestrovsc
    'dnestrovsc', 'dnestrovsk', 'днестровск',
    // Chitcani + satele comunei (cazul semnalat de client)
    'chitcani', 'chițcani', 'кицканы', 'кицкань', 'kitskany', 'kickany',
    'merenesti', 'merenești', 'меренешты',
    // Denumirea regiunii ca atare
    'transnistria', 'приднестровье', 'приднестровья', 'пмр', 'pmr'
  ];

  // Normalizare: lowercase, fara diacritice, fara semne de punctuatie.
  // Chirilicul nu are descompunere NFD utila aici, dar trece nemodificat.
  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, ' ')
      .trim();
  }

  var NORMALIZED = TERMS.map(normalize).filter(Boolean);

  /* Returneaza termenul gasit (pentru log/debug) sau null.
     Compara pe cuvant intreg ca "bender" sa nu prinda "Benderский..." parțial
     dintr-un alt cuvant si ca prefixele scurte sa nu produca fals pozitiv. */
  function findBlockedTerm(value) {
    var words = normalize(value).split(' ').filter(Boolean);
    if (words.length === 0) return null;
    for (var i = 0; i < NORMALIZED.length; i++) {
      var term = NORMALIZED[i];
      var parts = term.split(' ');
      if (parts.length === 1) {
        if (words.indexOf(term) !== -1) return TERMS[i];
      } else {
        // termen multi-cuvant: cauta secventa consecutiva
        for (var w = 0; w + parts.length <= words.length; w++) {
          var match = true;
          for (var p = 0; p < parts.length; p++) {
            if (words[w + p] !== parts[p]) { match = false; break; }
          }
          if (match) return TERMS[i];
        }
      }
    }
    return null;
  }

  window.PARFART_BLOCKED_REGIONS = {
    terms: TERMS,
    normalize: normalize,
    findBlockedTerm: findBlockedTerm,
    isBlocked: function (value) { return findBlockedTerm(value) !== null; }
  };
})();
